import { Typography } from "antd";
import { Link } from "react-router-dom";
import LegalPageLayout from "./LegalPageLayout";

const { Title, Paragraph, Text } = Typography;

export default function ClientTermsPage() {
  return (
    <LegalPageLayout title="Client Terms of Use" lastUpdated="October 22, 2026">
      <Paragraph>
        These terms apply to you if you book an appointment, use a client account, or otherwise interact with a
        salon or barbershop business ("the Business") through Hairplane's booking page or client app (the
        "Service"). Hairplane provides the software the Business uses — the Business is who you're booking with,
        and who's responsible for the appointment itself.
      </Paragraph>

      <Title level={4}>1. Booking Appointments</Title>
      <Paragraph>
        When you book an appointment, you're entering into an agreement with the Business, not with Hairplane.
        Cancellation policies, no-show fees, and pricing are set by the Business, not by us.
      </Paragraph>

      <Title level={4}>2. Your Account</Title>
      <Paragraph>
        If the Business offers a client account (e.g. to view appointment history or loyalty rewards), you may be
        asked to verify your phone number with a one-time code. Keep that access private — you're responsible for
        activity under your account.
      </Paragraph>

      <Title level={4}>3. Text Messages and Email</Title>
      <Paragraph>
        By providing your phone number, you may receive text messages related to your appointments (reminders,
        confirmations, waitlist notifications, and login codes) and, if you opt in, promotional messages from the
        Business. <Text strong>Message frequency varies. Message and data rates may apply.</Text> Reply{" "}
        <Text code>STOP</Text> at any time to opt out of non-essential messages, or <Text code>HELP</Text> for
        help. Consent to receive marketing text messages isn't required to book an appointment. The same applies
        to marketing emails, which include a working unsubscribe link.
      </Paragraph>

      <Title level={4}>4. Your Information</Title>
      <Paragraph>
        Information you provide (name, phone, email, appointment history) is entered into the Business's records
        in Hairplane on their behalf. See our <Link to="/privacy">Privacy Policy</Link> for more on how that
        information is handled. For questions about your specific data, the Business you booked with is usually
        the right first contact, since they control their own client records.
      </Paragraph>

      <Title level={4}>5. Conduct</Title>
      <Paragraph>
        Don't use the Service to harass staff or other users, submit false information, or attempt to access
        another client's account or data.
      </Paragraph>

      <Title level={4}>6. Disclaimer</Title>
      <Paragraph>
        The Service is provided "as is." Hairplane isn't responsible for the services the Business provides, the
        quality of an appointment, or disputes between you and the Business.
      </Paragraph>

      <Title level={4}>7. Changes</Title>
      <Paragraph>
        We may update these terms from time to time; the "Last updated" date above will reflect the most recent
        change.
      </Paragraph>

      <Title level={4}>8. Contact</Title>
      <Paragraph>
        Questions about the Service itself can be sent to <Text code>support@hairplane.com</Text>. Questions about
        a specific appointment should go to the Business you booked with.
      </Paragraph>
    </LegalPageLayout>
  );
}
